 export const API = {
    CMS: "https://cms.dawerha.ps"
};
